import { useSafeQuery } from '@gen2/hooks';
import { useMutation } from '@tanstack/react-query';
import { watch, unwatch, getWatchers } from './api';

export enum WatcherKeys {
  watch = 'watch',
  unwatch = 'unwatch',
  getWatchers = 'getWatchers',
}

export const useWatchMutation = () =>
  useMutation({
    mutationFn: watch,
  });

export const useUnwatchMutation = () =>
  useMutation({
    mutationFn: unwatch,
  });

export const useGetWatchersQuery = (inviteId: string) => {
  return useSafeQuery(
    [WatcherKeys.getWatchers, inviteId],
    async () => {
      const res = await getWatchers(inviteId);

      return res?.data?.data;
    },
    {
      enabled: !!inviteId,
    },
  );
};
